/*
  barna flow — S2 collection page.

  Three jobs only. Everything else on this page is Liquid and CSS, per CLAUDE.md
  ("Liquid first. Reach for JavaScript only when the behavior genuinely cannot be
  done in Liquid or CSS"):

    1. Measure the theme header so the sticky toolbar clears it instead of guessing.
    2. Submit the sort form on change — the form works without this, the <noscript>
       button is the fallback, this just removes a click.
    3. Reveal-on-scroll, which has no CSS-only equivalent with broad support.

  Quick add is not here: the theme's own <product-form> element (theme-global.js)
  already owns cart submission, and the card reuses it.
*/
(function () {
  'use strict';

  // Several sections emit this file, so the browser runs it once per tag. Without this
  // guard the sort select collects a change listener per copy and submits twice.
  if (window.__s2cInit) return;
  window.__s2cInit = true;

  var root = document.documentElement;

  /* ---------- 1. Header height ---------- */

  // This theme pins .m-header__wrapper (fixed) while .m-header itself stays relative, so
  // measuring by name is fragile. Take the first candidate that is actually pinned instead.
  var HEADER_SELECTORS = [
    '.m-header__wrapper',
    '.m-header--sticky',
    '[data-header-sticky]',
    '.m-header',
    'header'
  ];

  function measureHeader() {
    var height = 0;

    for (var i = 0; i < HEADER_SELECTORS.length; i++) {
      var el = document.querySelector(HEADER_SELECTORS[i]);
      if (!el) continue;

      var position = window.getComputedStyle(el).position;
      // A static header scrolls away, so the toolbar can sit flush at the top.
      if (position !== 'fixed' && position !== 'sticky') continue;

      height = el.offsetHeight;
      break;
    }

    root.style.setProperty('--s2c-head-h', height + 'px');
  }

  measureHeader();
  window.addEventListener('load', measureHeader);

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(measureHeader, 150);
  });

  // This theme only switches its header to fixed once the page scrolls, so a measurement
  // taken at load reports zero and the toolbar ends up underneath it. Re-measure while
  // scrolling, coalesced to one read per frame.
  var queued = false;
  window.addEventListener(
    'scroll',
    function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        measureHeader();
      });
    },
    { passive: true }
  );

  /* ---------- 2. Sort ---------- */

  document.querySelectorAll('[data-s2c-sort]').forEach(function (form) {
    var select = form.querySelector('select[name="sort_by"]');
    if (!select) return;

    select.addEventListener('change', function () {
      form.submit();
    });
  });

  /* ---------- 3. Reveal ---------- */

  var targets = document.querySelectorAll('.s2c-rise');
  if (!targets.length) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reduced.matches || typeof IntersectionObserver === 'undefined') {
    targets.forEach(function (el) {
      el.classList.add('is-in');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
